// 検査 1 件ごとの保存の ID（client_ref）。保存のたびに同じ値を送り、サーバー（api/_saveIdempotency.js）は
// 同じ ID の検査が既にあれば新しく保存せず 1 件目を返す。通信の再送・再保存・自動の再試行で同じ検査が
// 2 件になるのを防ぐ（2026-10-04、Food-Label Assist と同じ）。項目を作るときに 1 回だけ作り、項目に持たせる。
export function newSaveRef() {
  const c = typeof crypto !== 'undefined' ? crypto : undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  // randomUUID の無いブラウザ（古い端末・http の画面）。UUID v4 の形で作る
  if (c && typeof c.getRandomValues === 'function') {
    const b = c.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = Array.from(b, x => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  }
  return null; // 作れなければ送らない（これまでどおり毎回保存する）
}
